import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class AmplitudeService {
  private readonly initialized: boolean = false;

  constructor() {
    if (!environment.amplitudeId) {
      return;
    }
    this.initialized = true;
  }

  public logAmplitudeEvent(event: string, payload: { [key: string]: string }): void {
    if (!this.initialized) {
      return;
    }
    void amplitude.logEvent(event, payload).promise;
  }
}
